import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()
export class PushHttpService {
  private http = inject(HttpClient);
  private API_HOST = environment.API_HOST;

  public saveSubscription(subscription: PushSubscriptionJSON): Observable<void> {
    return this.http.post<void>(`${this.API_HOST}/web/push/subscribe`, subscription);
  }

  public deleteSubscription(endpoint: string): Observable<void> {
    return this.http.delete<void>(`${this.API_HOST}/web/push/subscribe`, { body: { endpoint } });
  }
}
